import FixedImage from './FixedImage'

export default FixedImage
